import { render, staticRenderFns } from "./StatsAccountTab.vue?vue&type=template&id=f992c46a&scoped=true&"
import script from "./StatsAccountTab.vue?vue&type=script&lang=js&"
export * from "./StatsAccountTab.vue?vue&type=script&lang=js&"
import style0 from "./StatsAccountTab.vue?vue&type=style&index=0&id=f992c46a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f992c46a",
  null
  
)

export default component.exports